import dialogComponent from './src/main';

function createDialog (V, slot, { title, width }, onSure, onCancel) {
  const h = this.$createElement;
  const dialog = new (V.extend(dialogComponent));

  dialog.onDestroy = function () {
    dialog.$destroy();
    onCancel && onCancel();
    document.body.removeChild(dialog.$el);
  };
  dialog.title = title;
  width && (dialog.width = width);
  dialog.onSure = onSure;
  dialog.$slots = { default: slot };
  dialog.$mount();
  document.body.appendChild(dialog.$el);
  return dialog;
}

export default ({
  install: Vue =>
    Vue.prototype.$dialog = function (slot, prop, onSure, onCancel) {
      return createDialog.call(this, Vue, slot, prop, onSure, onCancel);
    }
});